import { Component } from '@angular/core';

@Component({
    selector: 'loader-bar',
    templateUrl: 'loader-bar.component.html',
    styleUrls: ['loader-bar.component.scss'],
    standalone: false
})
export class LoaderBarComponent {}
